import React from 'react'
import { co2_reduced, coal_saved, trees_planted } from '../../Images/Icons';
import css from './HomePage.module.scss'
const EnvironmentalCard = (props) => {
    // console.log('env', props.dataEnv.return.envbenefit)
    if(!props.dataEnv) {
        return (
            
            <div style={{ marginTop: 10 }}>
                <div className={css.grid_environmental} style={{height:182}}>
                    <div class="loading element title_skeleton"></div>
                    <div class="loading element content_skeleton"></div>
                </div>
            </div>
        )
    }
    const data = props.dataEnv.return.envbenefit;

    return (
        <div style={{ marginTop: 20, paddingBottom: 20 }}>
            <div className={css.grid_environmental}>
                <div onClick={() => { }} className={css.header_environmental}>
                    <span>Environmental Benefits</span>
                </div>
                <div className={css.grid_content_environmental}>
                    <div className={css.content} style={{ marginLeft: 16 }}>
                        <div>
                            <div className={css.font_small}>{data.coal.toFixed(2)} t</div>
                            <div className={css.font_medium}>Standard coal saved</div>
                            <div className={css.image}>
                                <img src={coal_saved} />
                            </div>
                        </div>
                    </div>
                    <div className={css.content}>
                        <div>
                            <div className={css.font_small}>{data.co2.toFixed(2)} t</div>
                            <div className={css.font_medium}>CO<sub>2</sub>  reduced</div>
                            <div className={css.image}>
                                <img src={co2_reduced} />
                            </div>
                        </div>
                    </div>
                    <div className={css.content}>
                        <div>
                            <div className={css.font_small}>{data.trees.toFixed(0)} tree</div>
                            <div className={css.font_medium}>Equivalent trees planted</div>
                            <div className={css.image}>
                                <img src={trees_planted} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EnvironmentalCard